export const TRADE_CONFIRMATION_MODAL_DETAILS_CONTAINER_CLASSNAME =
	'flex flex-col gap-y-sm bg-input-bg border border-stroke-divider rounded-sm p-lg';
